import { Component, inject, signal, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SupportService } from 'src/app/services/support.service';
import { ReportDialogFacade } from 'src/app/_core/state/dialogs/report/report.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { checkboxValidator } from 'src/app/_core/validators/checkbox.validator';
import { ToastService } from '../../../../_core/services/toast.service';
import { TextareaComponent } from '../../forms/textarea/textarea.component';

@Component({
  selector: 'opac-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent {

  @ViewChild('descriptionTextarea') descriptionTextarea!: TextareaComponent;

  private readonly reportDialogFacade = inject(ReportDialogFacade);
  private readonly supportService = inject(SupportService);
  private readonly toastService = inject(ToastService);

  readonly open = toSignal(this.reportDialogFacade.open$);
  readonly descriptionMaxLength = signal<number>(2000);

  readonly reportForm: FormGroup;
  readonly labels = ['report.wrongMetadata', 'report.wrongCover', 'report.playIssues'];

  get checkboxes(): FormArray {
    return this.reportForm.get('checkboxes') as FormArray;
  }
  get details() { return this.reportForm.get('details'); }

  constructor() {
    this.reportForm = new FormGroup({
      checkboxes: new FormArray([
        new FormControl(null, Validators.required),
        new FormControl(null, Validators.required),
        new FormControl(null, Validators.required),
      ], { validators: checkboxValidator(1) }),
      details: new FormControl('', [Validators.required, Validators.maxLength(this.descriptionMaxLength())]),
    });
  }

  onSubmit(event: Event) {
    event.preventDefault();

    if (this.reportForm.invalid) {
      this.reportForm.markAllAsTouched();

      if (this.details.invalid) {
        this.descriptionTextarea.focus();
      }
      return;
    }

    const checkboxesValues = this.checkboxes.value.map((value) => value);

    this.supportService.report(
      checkboxesValues[0],
      checkboxesValues[1],
      checkboxesValues[2],
      this.details.value).subscribe({
        next: () => {
          this.toastService.showToast('messages.report.success');
          this.closeDialog();
        },
        error: () => {
          this.toastService.showToast('messages.error.unknown', 'error');
        }
      });
  }

  closeDialog() {
    this.reportForm.reset();
    this.reportDialogFacade.closeDialog();
  }
}
